import { ReactComponent as Home } from 'asset/IconsPack/at_grid-01.svg';
import { ReactComponent as Palette } from 'asset/IconsPack/at_palette.svg';
import { ReactComponent as Settings } from 'asset/IconsPack/at_settings-01.svg';
import { ReactComponent as Workflows } from 'asset/IconsPack/at_shield-tick.svg';
import { ReactComponent as User } from 'asset/IconsPack/at_user-01.svg';
import { ReactComponent as Integrations } from 'asset/icons/integration.svg';
import { ReactComponent as Tcm } from 'asset/icons/tcm_icon.svg';

export const navigationGroups = [
    {
        id: 'main',
        items: [
            { id: 'home', label: 'Home', path: '/dashboard', icon: <Home /> },
            { id: 'users', label: 'Users', path: '/users', icon: <User /> },
        ],
    },
    {
        id: 'verification',
        label: 'Medallion™',
        items: [
            {
                id: 'workflows',
                label: 'Workflows',
                path: '/workflows',
                icon: <Workflows />,
                hasSubPages: true,
            },
            {
                id: 'themes',
                label: 'Themes',
                path: '/workflows/themes',
                icon: <Palette />,
                hasSubPages: true,
                isNew: true,
            },
        ],
    },
    {
        id: 'monitoring',
        label: 'Monitoring™',
        items: [{ id: 'tcm', label: 'Continuous Monitoring', path: '/tcm', icon: <Tcm /> }],
    },
    {
        id: 'configuration',
        label: 'Configuration',
        items: [
            {
                id: 'integrations',
                label: 'Integrations',
                path: '/integrations',
                icon: <Integrations />,
            },
            {
                id: 'settings',
                label: 'Settings',
                path: '/settings',
                icon: <Settings />,
                hasSubPages: true,
            },
        ],
    },
];
